import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreMaterialModule } from '@nttp/core-material';
import { CoreUiModule } from '@nttp/core-ui';
import { FundAccountComponent } from '@pg-app/client/client-dashboard/components/fund-account/fund-account.component';
import { FundAccountModalComponent } from '@pg-app/client/client-dashboard/components/fund-account/modal/modal.component';
import { FundAccountService } from '@pg-app/client/client-dashboard/components/fund-account/service/fund-account.service';
import { SendPaymentInstructionModule } from '@pg-app/client/send-payment-instruction/send-payment-instruction.module';
import { FundOptionsComponent } from '@pg-app/client/client-dashboard/components/fund-account/fund-options/fund-options.component';
import { IOTBanksComponent } from '@pg-app/client/client-dashboard/components/fund-account/IOT/banks/iot-banks.component';
import { PipeModule } from '@nttp/pipes/pipe.module';
import { NgTableModule } from '@nttp/table/ng-table.module';
import { DebounceButtonModule } from '@pg-app/shared/components/debounce-button/debounce-button.module';

@NgModule({
  imports: [
    CommonModule,
    CoreUiModule,
    CoreMaterialModule,
    NgbModule,
    ReactiveFormsModule,
    SendPaymentInstructionModule,
    PipeModule,
    NgTableModule,
    DebounceButtonModule
  ],
  declarations: [
    FundAccountComponent,
    FundAccountModalComponent,
    FundOptionsComponent,
    IOTBanksComponent
  ],
  entryComponents: [
    FundAccountModalComponent,
    FundOptionsComponent,
    IOTBanksComponent
  ],
  providers: [FundAccountService],
  exports: [
    FundAccountComponent,
    FundAccountModalComponent
  ]
})
export class FundAccountModule { }
